import i18n from 'i18next'

export type MillistreamSectorLevel = 1 | 2 | 3

const levelNamespace: Record<MillistreamSectorLevel, 'level1' | 'level2' | 'level3'> = {
    1: 'level1',
    2: 'level2',
    3: 'level3',
}

export const translateMillistreamSector = (level: MillistreamSectorLevel, key: string | null | undefined): string => {
    if (!key) return ''

    return i18n.t(`entities.millistreamSectors.${levelNamespace[level]}.${key}`, {
        defaultValue: key,
    })
}
